export interface IAuthUser {
  name: string;
  email: string;
  phone: string;
  is_verified: boolean;
  user_role: number;
}

export class AuthUser implements IAuthUser {
  name: string;
  email: string;
  phone: string;
  is_verified: boolean;
  user_role: number;
  constructor(json: IAuthUser) {
    Object.assign(this, json);
  }

  public issued(): Date {
    return this['.issued'];
  }

  public expires(): Date {
    return this['.expires'];
  }

  public isExpired(): boolean {
    return new Date(this.expires()) <= new Date();
  }
}
